class ProductAccordion extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.toggleDrawer = this.toggleDrawer.bind(this)

    this.drawerEl = this.els.drawer.element
    this.overlayEl = this.els.overlay.element

    this.listeners.add(this.els.trigger.element, 'click', () => this.toggleDrawer(false))
    this.listeners.add(this.els.close.element, 'click', () => this.toggleDrawer(true))
    this.listeners.add(this.overlayEl, 'click', () => this.toggleDrawer(true))
  }

  portalDrawer () {
    if (this.drawerEl.parentElement === document.body) return

    document.body.appendChild(this.drawerEl)
    document.body.appendChild(this.overlayEl)
  }

  toggleDrawer (shouldClose) {
    if (shouldClose == true) {
      this.drawerEl.setAttribute('aria-hidden', 'true')
      document.body.classList.remove('util-Accordion-open')
    } else {
      this.portalDrawer()
      document.body.classList.add('util-Accordion-open')
      this.drawerEl.offsetHeight

      requestAnimationFrame(() => {
        this.drawerEl.setAttribute('aria-hidden', 'false')
      })
    }
  }
}

if (!customElements.get('product-accordion')) {
  customElements.define('product-accordion', ProductAccordion)
}
